import { PaymentAttributes } from "../payment/Payment"

export type Payment = {
    id: string,
    type: string,
    attributes: PaymentAttributes,
}

//todo define this
export type CreditCardDetails = {
    attributes: CreditCardDetailsAttributes
}
type CreditCardDetailsAttributes = {
    last4: string,
    brand: string,
    cardHolderName: string,
    expirationMonth: string,
    expirationYear: string,
}

export type BankDetails = {
    attributes: BankDetailsAttributes
}

type BankDetailsAttributes = {
    bankName: string,
    accountHolderName: string,
    last4: string,
    routingNumber: string,
    country: string,
    bankAccountToken: string,
    externalId: string,
}

export type ExternalCheckoutDetails = {
    attributes: ExternalCheckoutDetailsAttributes
}

type ExternalCheckoutDetailsAttributes = {
    paymentType: string,
}

export namespace PAYMENT_STATUS {
    export const CAPTURED = "captured"
    export const VOIDED = "voided"
    export const SYNC_REQUESTED = "sync-requested"
    export const PENDING = "pending"
    export const EXPIRED = "expired"
    export const DECLINED = "declined"

    export const REFUNDED = "refunded"
    export const PARTIALLY_REFUNDED = "partially-refunded"
    export const PAID = "paid"
    export const TRANSFERRED = "transferred"
    export const CANCELED = "canceled"
}
export type PAYMENT_STATUS = typeof PAYMENT_STATUS[keyof typeof PAYMENT_STATUS];

export namespace PAYMENT_3DS_STATUS {
    export const SUCCEEDED = "succeeded"
    export const FAILED = "failed"
}
export type PAYMENT_3DS_STATUS = typeof PAYMENT_3DS_STATUS[keyof typeof PAYMENT_3DS_STATUS];

export namespace PAYMENT_TYPE {
    export const CHECK = "check"
    export const CASH = "cash"
    export const CREDIT_CARD = "credit-card"
    export const ON_ACCOUNT = "on-account"
    export const CREDIT = "credit"
    export const BANK_TRANSFER = "bank-transfer"
    export const EXTERNAL_CHECKOUT = "external-checkout"
    export const EXTERNAL = "external"
    export const GIFT_CARD = "gift-card"
    export const PRICE_LIST_BULK_PAYMENT = "price-list-bulk-payment"
    export const PRICE_LIST_CREDIT_MEMO = "price-list-credit-memo"
}
export type PAYMENT_TYPE = typeof PAYMENT_TYPE[keyof typeof PAYMENT_TYPE];

export namespace PAYMENT_SOURCE {
    export const ONLINE = "online"
    export const BACKOFFICE = "back-office"
    export const RECURRING = "recurring"
}
export type PAYMENT_SOURCE = typeof PAYMENT_SOURCE[keyof typeof PAYMENT_SOURCE]

export namespace PAYMENT_METHOD {
    export const CREDIT_CARD = "credit-card"
    export const BANK_ACCOUNT = "bank-account"
}
export type PAYMENT_METHOD = typeof PAYMENT_METHOD[keyof typeof PAYMENT_METHOD]

export namespace DATA_3DSECURE_STATUS {
    export const SUCCEEDED = "succeeded"
    export const FAILED = "failed"
}
export type DATA_3DSECURE_STATUS = typeof DATA_3DSECURE_STATUS[keyof typeof DATA_3DSECURE_STATUS]



// WEBPACK FOOTER //
// ./src/state/helpers/Payment.ts